import { Expose, Transform, Type } from "class-transformer";
import { parseAppDate } from "@/utils/dates/dateFormats";

export class SetExecutionReportRegistrationDateBulkItemDto {
  @Expose()
  id: string;

  @Expose()
  type: "valuation" | "certification";
}

export class SetExecutionReportRegistrationDateBulkDto {
  @Expose()
  @Type(() => SetExecutionReportRegistrationDateBulkItemDto)
  items: SetExecutionReportRegistrationDateBulkItemDto[];

  @Transform(({ value }) => (value ? parseAppDate(value, false) : value))
  @Expose()
  registrationDate: Date;
}
